<template>
	<div>
		<div class="doctorPage doctorSeach managerPlan">
			<div class="selectSearch">
				<el-form ref="preservationform" :model="loginStatiscsParamters" class="qcFrom" :inline="true">
					<el-form-item label="关键词">
						<el-input v-model="loginStatiscsParamters.keyword" class="name" placeholder="用户名/手机号" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="角色名称">
						<el-select v-model="loginStatiscsParamters.roleGuids" placeholder="请选择角色名称" size="mini" class="name" >
							<el-option label="全部" value=""></el-option>
							<el-option v-for="item in rolesList" :key="item.RoleGuid" :label="item.RoleName" :value="item.RoleGuid">
							</el-option>
						</el-select>
					  </el-form-item>
					  <el-form-item label="登录时间">
					  	<el-date-picker
					  		class="time mar4"
					  		v-model="pickerDate"
					  		@change="datePicker"
					  		type="monthrange"
					  		size="mini"
					  		range-separator="至"
					  		start-placeholder="开始时间"
					  		end-placeholder="结束时间"
					  		value-format="yyyy/MM"
					  		format="yyyy-MM"
					  	></el-date-picker>
					  </el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search" round>查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 中间内容 -->
			<div class="centerHome">
				<div class="ccHomel">
					<div class="compentTable">
						<el-table class="qcTable" :data="loginStatiscslist.Users" v-loading="loading">
							<el-table-column prop="Name" label="用户名称" min-width="100"></el-table-column>
							<el-table-column prop="Count" label="登录次数" min-width="100"></el-table-column>
							<el-table-column prop="LoginId" label="手机号" min-width="100"></el-table-column>
							<el-table-column prop="Roles" label="用户角色" min-width="100"></el-table-column>
							<el-table-column prop="LatestDt" label="最新登录时间"></el-table-column>
						</el-table>
						<div class="pages">
							<el-pagination class="pageAll" layout="prev, pager, next" :total="loginStatiscslist.TotalCount" :page-size='loginStatiscsParamters.PageCount'
							 :current-page='loginStatiscsParamters.PageIndex' @current-change='currentChange'>
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from '@/js/api'
	export default {
		data() {
			return {
				total: 0,
				pickerDate:[]
			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['loading']),
			...Vuex.mapState('admin', ['rolesList']),
			...Vuex.mapState('managerUser', ['loginStatiscslist','loginStatiscsParamters']),
		},
		activated() {
			this.loginStatiscsParamters.pageIndex = 1;
			this.pickerDate.push(this.loginStatiscsParamters.startdt);
			this.pickerDate.push(this.loginStatiscsParamters.enddt);
			this.GetUserLoginList();
		},
		created(){
			this.GetRoles({
				enable: '1'
			});
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setLoading']),
			...Vuex.mapActions('breadcrumb', ['getAllHospitals']),
			...Vuex.mapActions('admin', ['GetRoles']),
			...Vuex.mapActions('managerUser', ['GetUserLoginList']),
			datePicker(event) {
				this.loginStatiscsParamters.startdt = event[0];
				this.loginStatiscsParamters.enddt = event[1];
			},
			search() {
				this.loginStatiscsParamters.pageIndex = 1;
				this.GetUserLoginList();
			},
			//分页
			currentChange(val) {
				this.loginStatiscsParamters.pageIndex = val;
				this.GetUserLoginList();
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			}
		}
	}
</script>
